import script from "./CompanyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyCard.vue?vue&type=script&setup=true&lang=js"

import "./CompanyCard.vue?vue&type=style&index=0&id=2cfcf600&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfcf600"]])

export default __exports__